export const PM_USERS_CREATE_USER_OPEN_MODAL = "PM_USERS_CREATE_USER_OPEN_MODAL";
export const PM_USERS_CREATE_USER_CLOSE_MODAL = "PM_USERS_CREATE_USER_CLOSE_MODAL";

export const PM_USERS_CREATE_USER_REQUEST = "PM_USERS_CREATE_USER_REQUEST";
export const PM_USERS_CREATE_USER_RESULT = "PM_USERS_CREATE_USER_RESULT";

export const PM_USERS_UPDATE_USER_REQUEST = "PM_USERS_UPDATE_USER_REQUEST";
export const PM_USERS_UPDATE_USER_RESULT = "PM_USERS_UPDATE_USER_RESULT";

export const PM_USERS_SEARCH_ROLES_REQUEST = "PM_USERS_SEARCH_ROLES_REQUEST";
export const PM_USERS_SEARCH_ROLES_RESULT = "PM_USERS_SEARCH_ROLES_RESULT";

export const PM_USERS_GET_USER_REQUEST = "PM_USERS_GET_USER_REQUEST";
export const PM_USERS_GET_USER_RESULT = "PM_USERS_GET_USER_RESULT";

